import api from './axiosInstance';
import type { OperationData } from '../components/modal/modalAddOperation';

export type SearchType = 'income' | 'expense';

export type SearchItem = {
  kind: 'tag' | 'category' | 'operation';
  id: number;
  title: string;
  type: SearchType;
  href: string;
  date?: string;
  amount?: string;
};

export type SearchResponse = {
  items: SearchItem[];
};

export async function globalSearch(params: { q: string; type?: SearchType; limit?: number }) {
  const { data } = await api.get<SearchResponse>('/search', {
    params: {
      q: params.q,
      type: params.type,
      limit: params.limit ?? 8,
    },
  });

  return data.items ?? [];
}

export async function getOperationFromSearch(item: SearchItem): Promise<OperationData> {
  if (item.kind !== 'operation') {
    throw new Error('Search item is not an operation');
  }

  const endpoint = item.type === 'income' ? `/incomes/${item.id}` : `/expenses/${item.id}`;
  const { data } = await api.get<OperationData>(endpoint);

  return {
    ...data,
    type: item.type,
  };
}
